import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { IHttpError } from "types/http";
import {
  IZnsTemplate,
  IZnsTemplateListParams,
} from "../types/znsTemplate";

export interface IZnsTemplatesData {
  results: IZnsTemplate[];
  totalCount: number;
  lastPulledDate: string;
}

export interface IZnsTemplateState {
  loading?: boolean;
  data?: IZnsTemplatesData;
  error?: IHttpError;
  syncLoading?: boolean;
  syncSuccess?: boolean;
  syncError?: IHttpError;
}

const initialState: IZnsTemplateState = {
  loading: false,
  syncLoading: false,
};

export const znsTemplateSlice = createSlice({
  name: "znsTemplate",
  initialState,
  reducers: {
    loadZnsTemplates: (
      state,
      _action: PayloadAction<IZnsTemplateListParams>
    ) => {
      state.loading = true;
      state.data = undefined;
      state.error = undefined;
    },
    loadZnsTemplatesSuccess: (
      state,
      action: PayloadAction<IZnsTemplatesData>
    ) => {
      state.loading = false;
      state.data = action.payload;
    },
    loadZnsTemplatesFailed: (state, action: PayloadAction<IHttpError>) => {
      state.loading = false;
      state.error = action.payload;
    },
    syncZnsTemplates: (state) => {
      state.syncLoading = true;
      state.syncError = undefined;
      state.syncSuccess = false;
    },
    syncZnsTemplatesSuccess: (state) => {
      state.syncLoading = false;
      state.syncSuccess = true;
    },
    syncZnsTemplatesFailed: (state, action: PayloadAction<IHttpError>) => {
      state.syncLoading = false;
      state.syncError = action.payload;
    },
    clearSyncSuccess: (state) => {
      state.syncSuccess = false;
    },
  },
});

export const {
  loadZnsTemplates,
  loadZnsTemplatesSuccess,
  loadZnsTemplatesFailed,
  syncZnsTemplates,
  syncZnsTemplatesSuccess,
  syncZnsTemplatesFailed,
  clearSyncSuccess,
} = znsTemplateSlice.actions;

export const selectZnsTemplatesData = (state: RootState) =>
  state.znsTemplate?.data;
export const selectZnsTemplatesResults = (state: RootState) =>
  state.znsTemplate?.data?.results ?? [];
export const selectZnsTemplatesTotalCount = (state: RootState) =>
  state.znsTemplate?.data?.totalCount ?? 0;
export const selectZnsTemplatesLoading = (state: RootState) =>
  state.znsTemplate?.loading ?? false;
export const selectZnsTemplatesError = (state: RootState) =>
  state.znsTemplate?.error;
export const selectZnsTemplatesSyncLoading = (state: RootState) =>
  state.znsTemplate?.syncLoading ?? false;
export const selectZnsTemplatesSyncSuccess = (state: RootState) =>
  state.znsTemplate?.syncSuccess ?? false;
export const selectZnsTemplatesSyncError = (state: RootState) =>
  state.znsTemplate?.syncError;

export const selectZnsTemplatesLastPulledDate = (state: RootState) =>
  state.znsTemplate?.data?.lastPulledDate ?? "";

export default znsTemplateSlice.reducer;
